import { render, staticRenderFns } from "./StopList.vue?vue&type=template&id=2b88f35e"
import script from "./StopList.vue?vue&type=script&lang=js"
export * from "./StopList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports